import { useMutation } from '@tanstack/react-query';
import { verifyPhone } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useVerifyPhone({
  onSuccessFn = () => null,
  onErrorFn = () => null,
} = {}) {
  const Request = useMutation({
    mutationFn: verifyPhone,
    mutationKey: ['verifyPhone'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        onErrorFn();
        return toastEmitter('error', responseData?.error?.message);
      }
      onSuccessFn();
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
